// Saga
import { call, all, put, takeLatest, takeEvery } from "redux-saga/effects";

import {
  GET_MASTER_REPORTING_ITEM_LIST,
  GET_MASTER_REPORTING_ITEM_DATA,
} from "./actionType";

import {
  getMasterReportingItemListSuccess,
  getMasterReportingItemListFailure,
  getMasterReportingItemDataSuccess,
  getMasterReportingItemDataFailure,
} from "./action";

import {
  getMasterReportingItemListApi,
  getMasterReportingItemDataApi,
} from "../../helpers/fakebackend_helper";

function* getMasterReportingItemListSaga() {
  try {
    const response = yield call(getMasterReportingItemListApi);
    yield put(getMasterReportingItemListSuccess(response));
  } catch (error) {
    yield put(getMasterReportingItemListFailure(error));
  }
}

function* watchGetMasterReportingItemListSaga() {
  yield takeEvery(
    GET_MASTER_REPORTING_ITEM_LIST,
    getMasterReportingItemListSaga
  );
}

//Get Master Reporting item data
function* getMasterReportingItemDataSaga(action) {
  try {
    const response = yield call(getMasterReportingItemDataApi, action.payload);
    yield put(getMasterReportingItemDataSuccess(response));
  } catch (error) {
    yield put(getMasterReportingItemDataFailure(error));
  }
}

function* watchGetMasterReportingItemDataSaga() {
  yield takeEvery(
    GET_MASTER_REPORTING_ITEM_DATA,
    getMasterReportingItemDataSaga
  );
}

export default function* ReportingDashboard() {
  yield all([
    watchGetMasterReportingItemListSaga(),
    watchGetMasterReportingItemDataSaga(),
  ]);
}
